// src/components/admin/services/DeleteConfirmModal.jsx
import { useState } from "react";
import { X, AlertTriangle, Loader2 } from "lucide-react";
import useAxiosAdmin from "../../lib/axiosAdmin";
import {toast} from "react-toastify";
import { SET_SHOULD_REFRESH_ADMIN_STAFF } from "../../../../redux/action/admin/staff/type";
import { useDispatch } from "react-redux";

const DeleteConfirmModal = ({ service, onClose, onSuccess }) => {
  const axiosAdmin = useAxiosAdmin();
  const [loading, setLoading] = useState(false);
  
  const dispatch = useDispatch()

  const handleDelete = async () => {
    try {
      setLoading(true);

      await axiosAdmin.delete(`/api/admin/services/${service._id}`);

      toast.success("خدمت با موفقیت حذف شد");
      onSuccess();

      dispatch({
        type: SET_SHOULD_REFRESH_ADMIN_STAFF,
        payload: true
      });

    } catch (err) {
      console.error("خطا در حذف خدمت:", err);
      toast.error(err.response?.data?.message || "خطا در حذف خدمت");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
            <h2 className="text-lg font-bold text-slate-800">تأیید حذف</h2>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors disabled:opacity-50"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-sm text-slate-600 mb-3">
            آیا از حذف این خدمت اطمینان دارید؟
          </p>
          <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
            <p className="text-sm font-medium text-slate-800">
              {service.name}
            </p>
          </div>
          <p className="text-xs text-red-600 mt-3">
            ⚠️ این خدمت از لیست خدمات تمام کارکنان نیز حذف خواهد شد
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-lg transition-colors disabled:opacity-50"
          >
            انصراف
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                <span>در حال حذف...</span>
              </>
            ) : (
              <span>حذف خدمت</span>
            )}
          </button>
        </div>

      </div>
    </div>
  );
};

export default DeleteConfirmModal;